import { render, staticRenderFns } from "./DatasetCollectionDialog.vue?vue&type=template&id=7c977a3e"
import script from "./DatasetCollectionDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./DatasetCollectionDialog.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports